import { useMutation } from 'react-query';
import { CheckEmailAvailableRequest } from '../../../requests/Auth/CheckEmailAvailableRequest';

type Props = {
	onError: () => void;
	onSuccess: () => void;
};

export const useCheckEmailAvailableMutation = ({
	onError,
	onSuccess,
}: Props) => {
	return useMutation((email: string) => CheckEmailAvailableRequest(email), {
		onSuccess: (response: boolean) => {
			if (response === false) return onError();
			onSuccess();
		},
		onError: onError,
	});
};
